import * as React from "react";
import { ChartDataInput, DASHBOARD_STYLES, ChartCellType, DashboardUsage } from "src/common";
import { ChartLabel } from "./";
import _ from "lodash";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from "recharts";

type AllProps = {
    data?: ChartDataInput[];
    cells: ChartCellType[];
    title: string;
    total?: number;
}

// Description: Render the dashboard charts component
function DashboardChartsComponent(props: AllProps) {
    const { data, cells, title, total } = props;

    return <div className="recharts-card">
        <div className="recharts-card-title">{title}</div>
        <div className="recharts-card-chart">
            <ResponsiveContainer width="100%" height="100%" initialDimension={{ width: 100, height: 100 }}>
                <PieChart margin={DASHBOARD_STYLES.CHART_MARGIN}>
                    <Pie
                        data={data}
                        dataKey="value"
                        nameKey="name"
                        innerRadius={50}
                        outerRadius={90}
                        startAngle={90}
                        endAngle={-270}
                        paddingAngle={2}
                        labelLine={false}
                        label={<ChartLabel total={total} />}>
                        {
                            _.map(cells, (cell) => {
                                return <Cell key={cell.key} fill={cell.fill} />;
                            })
                        }
                    </Pie>
                    {/* NOTE: any — recharts formatter payload types aren't cleanly exported */}
                    <Tooltip formatter={(_v: any, _name: any, item: any) => DashboardUsage.convertUsageToFriendlySize(item.payload.value)} />
                    {/* NOTE: any — recharts formatter payload types aren't cleanly exported */}
                    <Legend
                        align="left"
                        iconType="circle"
                        verticalAlign="bottom"
                        wrapperStyle={DASHBOARD_STYLES.LEGEND_MARGIN}
                        formatter={(_v: any, entry: any) => DashboardUsage.convertUsageToFriendlySize(entry.payload?.value)} />
                </PieChart>
            </ResponsiveContainer>
        </div>
    </div>;
}

export default React.memo(DashboardChartsComponent);
